<script>
import store from '../../store/store';

export default {
    name: 'NavigationMixin',

    data() {
      return {
        store,
      }
    },

    methods: {
        $_navigationMixin_navigateBack: function() {
            window.history.back();
        },
        
        $_navigationMixin_linkIsDisabled: function(item) {
            if (item.name === "Complete" && (!this.charitySelected() || !this.eventSelected()))
                return true;

            return false;
        },

        $_navigationMixin_itemSelected: function(item) {
            if (item.name.toLowerCase() === "cause") {
                return this.charitySelected();
            }

            if (item.name.toLowerCase() === "event") {
                return this.eventSelected();
            }

            if (item.name.toLowerCase() === "select team") {
                return this.teamSelected();
            }

             if (item.name.toLowerCase() === "complete") {
                return (this.charitySelected() && this.eventSelected()) || this.teamSelected();
            }

            return false;
        },
            
        eventSelected: function() {
            return this.store.state.selected_event !== '' || (this.store.state.pageType === 'joinTeam' && this.teamSelected())
        },

        charitySelected: function() {
            return this.store.state.selected_charity !== '' || (this.store.state.pageType === 'joinTeam' && this.teamSelected());
        },

        teamSelected: function() {
            return this.store.state.selected_teampage !== '';
        }
    }
}
</script>
